import { makeStyles } from '@material-ui/core/styles';
import { componentDimensions } from 'UI/constants/dimensions';

export const useDrawerStyles = makeStyles(theme => ({
  drawerLarge: {
    width: componentDimensions.drawer.large.width,
    overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '80%'
    }
  }
}));
